'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var organismClass = 'fees-intent';

var FeesCalculatorIntent = function (_React$Component) {
  _inherits(FeesCalculatorIntent, _React$Component);

  function FeesCalculatorIntent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FeesCalculatorIntent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FeesCalculatorIntent.__proto__ || Object.getPrototypeOf(FeesCalculatorIntent)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
      e.preventDefault();
      if (_this.props.handleChange) {
        _this.props.handleChange(e.target.selectedIndex);
        _this.props.fireTracking('FeeCalc-DropDown-' + e.target.value);
      }
    }, _this.renderHeadline = function (headline) {
      if (headline) {
        var headlineClass = organismClass + '__headline h3';
        return _react2.default.createElement(
          _heading2.default,
          { level: '2', className: headlineClass },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    }, _this.renderSubheadline = function (subheadline) {
      if (subheadline) {
        var subheadlineClass = organismClass + '__subheadline';
        return _react2.default.createElement(
          _heading2.default,
          { level: '4', className: subheadlineClass },
          _react2.default.createElement(
            'label',
            { htmlFor: organismClass + '__select__' + subheadline.text.split(' ').join('') },
            htmlToReactParser.parse(subheadline.text)
          )
        );
      }
      return null;
    }, _this.renderSelect = function (items, id) {
      if (items) {
        var options = items.map(function (item) {
          return _react2.default.createElement(
            'option',
            { key: 'option-item' + item.text },
            htmlToReactParser.parse(item.text)
          );
        });

        return _react2.default.createElement(
          'div',
          { className: organismClass + '__select-wrapper' },
          _react2.default.createElement(
            'select',
            {
              className: organismClass + '__select',
              onChange: _this.handleChange,
              id: organismClass + '__select__' + id
            },
            options
          )
        );
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // passing the id, so that in case there are multiple fees calculator organisms in a page
  // then assumption is that the sub-headline will be different.


  _createClass(FeesCalculatorIntent, [{
    key: 'render',
    value: function render() {
      var _props$content = this.props.content,
          headline = _props$content.headline,
          subheadline = _props$content.subheadline,
          items = _props$content.items;

      var id = subheadline && subheadline.text && subheadline.text.split(' ').join('');
      return _react2.default.createElement(
        'div',
        { className: organismClass + ' col-md-10 col-xs-12 col-sm-9' },
        this.renderHeadline(headline),
        this.renderSubheadline(subheadline),
        this.renderSelect(items, id)
      );
    }
  }]);

  return FeesCalculatorIntent;
}(_react2.default.Component);

exports.default = FeesCalculatorIntent;


FeesCalculatorIntent.propTypes = {
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    subheadline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired).isRequired
  }),
  handleChange: _propTypes2.default.func,
  fireTracking: _propTypes2.default.func
};

FeesCalculatorIntent.defaultProps = {
  content: {
    headline: {
      text: '25 characters maximum'
    },
    subheadline: {
      text: '30 characters maximum:'
    },
    items: [{
      text: '25 characters maximum'
    }, {
      text: '25 characters maximum'
    }]
  },
  fireTracking: function fireTracking() {},
  handleChange: function handleChange() {}
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/fees-calculator-intent/jsx/FeesCalculatorIntent.js
// module id = 665
// module chunks = 4